import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
var AppItem = /*#__PURE__*/function (_React$Component) {
  function AppItem() {
    _classCallCheck(this, AppItem);
    return _callSuper(this, AppItem, arguments);
  }
  _inherits(AppItem, _React$Component);
  return _createClass(AppItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checked = _this$props.checked,
        onToggle = _this$props.onToggle,
        name = _this$props.name,
        title = _this$props.title,
        description = _this$props.description,
        t = _this$props.t,
        ns = _this$props.ns;
      var required = this.props.required || false;
      var optOut = this.props.optOut || false;
      var purposes = this.props.purposes || [];
      var onChange = function onChange(e) {
        onToggle(e.target.checked);
      };
      var id = "orejime-app-item-".concat(name);
      var isChecked = checked || required;
      var purposesText = purposes.map(function (purpose) {
        return t(['purposes', purpose]);
      }).join(', ');
      var optOutText = optOut ? /*#__PURE__*/React.createElement("span", {
        className: ns('AppItem-optOut'),
        title: t(['app', 'optOut', 'description'])
      }, t(['app', 'optOut', 'title'])) : '';
      var requiredText = required ? /*#__PURE__*/React.createElement("span", {
        className: ns('AppItem-required'),
        title: t(['app', 'required', 'description'])
      }, t(['app', 'required', 'title'])) : '';
      var purposesEl = purposes.length > 0 ? /*#__PURE__*/React.createElement("p", {
        className: ns('AppItem-purposes')
      }, t(['app', purposes.length > 1 ? 'purposes' : 'purpose']), ":", ' ', purposesText) : null;
      var switchLabel = isChecked ? 'enabled' : 'disabled';
      return /*#__PURE__*/React.createElement("div", {
        className: ns('AppItem')
      }, /*#__PURE__*/React.createElement("span", {
        className: ns('AppItem-arrow')
      }), /*#__PURE__*/React.createElement("input", {
        id: id,
        className: ns('AppItem-input'),
        "aria-describedby": "".concat(id, "-description"),
        disabled: required,
        checked: isChecked,
        type: "checkbox",
        onChange: onChange
      }), /*#__PURE__*/React.createElement("label", _extends({
        htmlFor: id,
        className: ns('AppItem-label')
      }, required ? {
        tabIndex: '0'
      } : {}), /*#__PURE__*/React.createElement("span", {
        className: ns('AppItem-title')
      }, t([name, 'title']) || title), requiredText, optOutText, /*#__PURE__*/React.createElement("span", {
        className: ns("AppItem-switch ".concat(required ? 'AppItem-switch--disabled' : ''))
      }, /*#__PURE__*/React.createElement("div", {
        className: ns('AppItem-slider')
      }), /*#__PURE__*/React.createElement("div", {
        "aria-hidden": "true",
        className: ns('AppItem-switchLabel')
      }, t(switchLabel)))), /*#__PURE__*/React.createElement("div", {
        id: "".concat(id, "-description"),
        className: ns('AppItem-fullDescription')
      }, /*#__PURE__*/React.createElement("p", {
        className: ns('AppItem-description'),
        dangerouslySetInnerHTML: {
          __html: t([name, 'description']) || description
        }
      }), purposesEl));
    }
  }]);
}(React.Component);
export { AppItem as default };